import React, { FC, useEffect, useState } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Copyright from '../../components/Copyright';
import { useForm, SubmitHandler } from 'react-hook-form';
import LoadingButton from '../../components/buttons/LoadingButton';
import { useHistory } from 'react-router-dom';
import * as auth from '../../api/auth';
import ConfirmDialog from '../../components/dialogs/ConfirmDialog';
import InfoHelpDialog from '../../components/dialogs/InfoDialog';
import ErrorDialog from '../../components/dialogs/ErrorDialog';


const useStyles = makeStyles((theme: Theme) => ({
    root: {
        height: '100vh',
    },
    container: {
        display: 'flex',
        justifyContent: 'center',
        height: '100%',
    },
    paper: {
        margin: theme.spacing(8, 4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    }
}));

type FormValues = {
    email: string;
}

const ForgotPassword: FC = () => {
    const classes = useStyles();
    const { register, handleSubmit, errors } = useForm<FormValues>();
    const history = useHistory();
    const [userEmail, setUserEmail] = useState('');
    const [infoOpen, setInfoOpen] = useState(false);
    const [userFound, setUserFound] = useState(false);
    const [resetOpen, setResetOpen] = useState(false);
    const [errorOpen, setErrorOpen] = useState(false);
    const [pending, setPending] = useState(false);
    const [goToLogin, setGoToLogin] = useState(false);


    useEffect(() => {
        console.clear()
    }, [])


    useEffect(() => {
        if (goToLogin) {
            history.push("/login");
        }
    }, [goToLogin])


    const handleGoToLogin = () => {
        setGoToLogin(true);
    };


    const resetEmail = async () => {
        setPending(true);
        const user = await auth.getUser(userEmail).catch(_ => { });
        if (!user) {
            setUserFound(false);
            console.clear();
            setInfoOpen(true);
        }
        else {
            setUserFound(true);
            sendEmail(userEmail);
            console.clear();
        }
        setPending(false);
    }

    const sendEmail = async (email: string) => {
        const send = await auth.sendEmail(email).catch(_ => { });
        setInfoOpen(true);
        console.clear();
    };

    const handleChange = (e: any) => {
        if (e.target.name === "email") {
            setUserEmail(e.target.value);
        }
    };

    const confirmReset = (e: any) => {
        e.preventDefault();
        if(userEmail != '' && /\S+@\S+\.\S+/.test(userEmail)){
            setResetOpen(true);
        }
        else {
            setErrorOpen(true);
        }
    };

    const handleCloseInfo = () => {
        setInfoOpen(false)
        handleGoToLogin();
    };


    return (
        <Grid container component="main" className={classes.root}>
            <CssBaseline />
            <Grid container justify="center" alignItems="center" item xs={12} sm={12} md={12} lg={12}>
                <Grid item xs={12} sm={12} md={6} className={classes.container}>
                    <div className={classes.paper}>
                        <Typography component="h1" variant="h5">
                            Nulstil Kodeord
                        </Typography>
                        <form className={classes.form} noValidate onSubmit={confirmReset}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label="Email"
                                name="email"
                                autoComplete="email"
                                autoFocus
                                onChange={handleChange}
                                inputRef={register({
                                    required: true,
                                })}
                            />
                            <LoadingButton pending={pending} text={"Nulstil"} update={() => { }} />
                            <Grid container>
                                <Grid item xs style={{ textAlign: 'left' }}>
                                    <Link onClick={handleGoToLogin} variant="body2" style={{ cursor: 'pointer' }}>
                                        Gå tilbage til login?
                                    </Link>
                                </Grid>
                            </Grid>
                            <Box mt={5}>
                                <Copyright />
                            </Box>
                        </form>
                    </div>
                </Grid>
            </Grid>
            <ConfirmDialog
                title={`Sikker på du vil nulstille kodeordet til konto: ${userEmail} ?`}
                text={'Nulstil'}
                open={resetOpen}
                onConfirm={() => {
                    setResetOpen(false);
                    resetEmail();
                }}
                onClose={() => setResetOpen(false)}
            />
            <InfoHelpDialog
                title={`Email med link til nulstilling af kodeord sendt`}
                text={`Du har modtaget et link på mail: ${userEmail}.
                \nNulstil dit kodeord via linket på mail.
                \nDu vil nu blive omdirigeret til login siden.`}
                open={infoOpen}
                onClose={() => handleCloseInfo()}
            />
            <ErrorDialog
                title={`FEJL`}
                text={`Ugyldig email`}
                open={errorOpen}
                onClose={() => setErrorOpen(false)}
            />
        </Grid>
    );
}

export default ForgotPassword;